import i18n from "../../../i18n";

export const DietDairyTypes = {
  FAVORITES: "favorites",
  FOOD_DRINK: "food_drink",
  STUDY_DRUG: "study_drug",
};

export const dietDairyTypeToString = (type) => {
  switch (type) {
    case DietDairyTypes.FOOD_DRINK:
      return i18n.t("appText.dietDiary.foodDrink");
    case DietDairyTypes.STUDY_DRUG:
      return i18n.t("appText.dietDiary.studyDrug");
    default:
      return i18n.t("appText.dietDiary.foodDrink");
  }
};

export const NUTRITION_FIELDS = [
  {
    title: "Calories",
    translationId: "appText.dietDiary.nutritionTable.calories",
    aboutMealLetter: "Calories",
    attr_id: 208,
    unit: "kcal",
    isVisibleInTable: true,
  },
  {
    title: "Total Fat",
    translationId: "appText.dietDiary.nutritionTable.totalFat",
    aboutMealLetter: "Fats",
    attr_id: 204,
    unit: "g",
    isVisibleInTable: true,
  },
  {
    title: "Saturated Fat",
    translationId: "appText.dietDiary.nutritionTable.saturatedFat",
    aboutMealLetter: "SaturatedFat",
    attr_id: 606,
    unit: "g",
    isVisibleInTable: true,
  },
  {
    title: "Medium Chain Fats",
    translationId: "appText.dietDiary.mediumChainFats",
    chartTitle: "appText.dietDiary.mcf",
    aboutMealLetter: "MediumChainFats",
    attr_id: -900,
    unit: "g",
    isVisibleInTable: true,
  },
  {
    title: "Long Chain Fats",
    translationId: "appText.dietDiary.longChainFats",
    chartTitle: "appText.dietDiary.lcf",
    aboutMealLetter: "LongChainFats",
    attr_id: -901,
    unit: "g",
    isVisibleInTable: true,
  },
  {
    title: "Protein",
    translationId: "appText.dietDiary.nutritionTable.protein",
    aboutMealLetter: "Protein",
    attr_id: 203,
    unit: "g",
    isVisibleInTable: true,
  },
  {
    title: "Carbohydrates",
    translationId: "appText.dietDiary.carbohydrates",
    chartTitle: "appText.dietDiary.carbs",
    aboutMealLetter: "Carbs",
    attr_id: 205,
    unit: "g",
    isVisibleInTable: true,
  },
  {
    title: "DHA",
    translationId: "appText.dietDiary.nutritionTable.dha",
    aboutMealLetter: "DHA",
    attr_id: 621,
    unit: "g",
    isVisibleInTable: true,
  },
  {
    title: "Vitamin A",
    translationId: "appText.dietDiary.nutritionTable.vitaminA",
    aboutMealLetter: "VitaminA",
    attr_id: 318,
    unit: "IU",
    isVisibleInTable: true,
  },
  {
    title: "Vitamin D",
    translationId: "appText.dietDiary.nutritionTable.vitaminD",
    aboutMealLetter: "VitaminD",
    attr_id: 324,
    unit: "IU",
    isVisibleInTable: true,
  },
  {
    title: "Vitamin E",
    translationId: "appText.dietDiary.nutritionTable.vitaminE",
    aboutMealLetter: "VitaminE",
    attr_id: 323,
    unit: "mg",
    isVisibleInTable: true,
  },
  {
    title: "Vitamin E (IU)",
    translationId: "appText.dietDiary.nutritionTable.vitaminE_IU",
    aboutMealLetter: "VitaminE_IU",
    attr_id: -800,
    unit: "IU",
    isVisibleInTable: true,
  },
  {
    title: "Vitamin K",
    translationId: "appText.dietDiary.nutritionTable.vitaminK",
    aboutMealLetter: "VitaminK",
    attr_id: 430,
    unit: "mcg",
    isVisibleInTable: true,
  },
  {
    title: "Fiber",
    translationId: "",
    aboutMealLetter: "Fiber",
    attr_id: 291,
    unit: "g",
  },
  {
    title: "Linoleic Acid",
    translationId: "",
    aboutMealLetter: "LinoleicAcid",
    attr_id: 618,
    unit: "g",
  },
  {
    title: "Linolenic Acid",
    translationId: "",
    aboutMealLetter: "LinolenicAcid",
    attr_id: 619,
    unit: "g",
  },
  {
    title: "ALA",
    translationId: "",
    aboutMealLetter: "ALA",
    attr_id: 815,
    unit: "g",
  },
  {
    title: "Iron",
    translationId: "appText.dietDiary.nutritionTable.iron",
    aboutMealLetter: "Iron",
    attr_id: 303,
    unit: "mg",
  },
  {
    title: "Zinc",
    translationId: "",
    aboutMealLetter: "Zinc",
    attr_id: 309,
    unit: "mg",
  },
  {
    title: "Calcium",
    translationId: "appText.dietDiary.nutritionTable.calcium",
    aboutMealLetter: "Calcium",
    attr_id: 301,
    unit: "mg",
  },
  {
    title: "Fluoride",
    translationId: "",
    aboutMealLetter: "Fluoride",
    attr_id: 313,
    unit: "mcg",
  },
  {
    title: "Folate, total",
    translationId: "",
    aboutMealLetter: "FolateTotal",
    attr_id: 417,
    unit: "mcg",
  },
  {
    title: "Cholesterol",
    translationId: "",
    aboutMealLetter: "Cholesterol",
    attr_id: 601,
    unit: "mg",
  },
  {
    title: "Fatty acids, total saturated",
    translationId: "",
    aboutMealLetter: "FattyAcids_TotalSaturated",
    attr_id: 606,
    unit: "g",
  },
  {
    title: "Fatty acids, total trans",
    translationId: "",
    aboutMealLetter: "FattyAcids_TotalTrans",
    attr_id: 605,
    unit: "g",
  },
  {
    title: "Potassium",
    translationId: "",
    aboutMealLetter: "Potassium",
    attr_id: 306,
    unit: "mg",
  },
  {
    title: "Sodium",
    translationId: "appText.dietDiary.nutritionTable.sodium",
    aboutMealLetter: "Sodium",
    attr_id: 307,
    unit: "mg",
  },
  {
    title: "Sugars, total",
    translationId: "",
    aboutMealLetter: "SugarsTotal",
    attr_id: 269,
    unit: "g",
  },
  {
    title: "Sugars, added",
    translationId: "",
    aboutMealLetter: "SugarsAdded",
    attr_id: 539,
    unit: "g",
  },
  {
    title: "Choline, total",
    translationId: "",
    aboutMealLetter: "CholineTotal",
    attr_id: 421,
    unit: "mg",
  },
  {
    title: "Copper",
    translationId: "",
    aboutMealLetter: "Copper",
    attr_id: 312,
    unit: "mg",
  },
  {
    title: "Folic Acid",
    translationId: "",
    aboutMealLetter: "FolicAcid",
    attr_id: 431,
    unit: "mcg",
  },
  {
    title: "Magnesium",
    translationId: "",
    aboutMealLetter: "Magnesium",
    attr_id: 304,
    unit: "mg",
  },
  {
    title: "Manganese",
    translationId: "",
    aboutMealLetter: "Manganese",
    attr_id: 315,
    unit: "mg",
  },
  {
    title: "Niacin",
    translationId: "",
    aboutMealLetter: "Niacin",
    attr_id: 406,
    unit: "mg",
  },
  {
    title: "Phosphorus",
    translationId: "",
    aboutMealLetter: "Phosphorus",
    attr_id: 305,
    unit: "mg",
  },
  {
    title: "Riboflavin",
    translationId: "",
    aboutMealLetter: "Riboflavin",
    attr_id: 405,
    unit: "mg",
  },
  {
    title: "Selenium",
    translationId: "",
    aboutMealLetter: "Selenium",
    attr_id: 317,
    unit: "mg",
  },
  {
    title: "Thiamin",
    translationId: "",
    aboutMealLetter: "Thiamin",
    attr_id: 404,
    unit: "mg",
  },
  {
    title: "Vitamin B-12",
    translationId: "",
    aboutMealLetter: "VitaminB12",
    attr_id: 418,
    unit: "mcg",
  },
  {
    title: "Vitamin B-6",
    translationId: "",
    aboutMealLetter: "VitaminB6",
    attr_id: 415,
    unit: "mg",
  },
  {
    title: "Vitamin C, total ascorbic acid",
    translationId: "",
    aboutMealLetter: "VitaminC_TotalAscorbicAcid",
    attr_id: 401,
    unit: "mg",
  },
  {
    title: "L-Carnitine",
    translationId: "",
    aboutMealLetter: "L_Carnitine",
    attr_id: -700,
    unit: "mg",
  },
  {
    title: "Monounsatured Fat",
    translationId: "",
    aboutMealLetter: "MonounsaturedFat",
    attr_id: 645,
    unit: "g",
  },
  {
    title: "Polyunsaturated Fat",
    translationId: "",
    aboutMealLetter: "PolyunsaturatedFat",
    attr_id: 646,
    unit: "g",
  },
  {
    title: "Vitamin A RE",
    translationId: "",
    aboutMealLetter: "VitaminA_RE",
    attr_id: 320,
    unit: "mcg",
  },
  {
    title: "Vitamin D",
    translationId: "",
    aboutMealLetter: "VitaminD_mcg",
    attr_id: 328,
    unit: "mcg",
  },
  {
    title: "Pantothenic Acid",
    translationId: "",
    aboutMealLetter: "PantothenicAcid",
    attr_id: 410,
    unit: "mg",
  },
  {
    title: "Vitamin A BE",
    translationId: "",
    aboutMealLetter: "VitaminA_BE",
    attr_id: -100,
    unit: "mcg",
  },
  {
    title: "Biotin",
    translationId: "",
    aboutMealLetter: "Biotin",
    attr_id: -101,
    unit: "mcg",
  },
  {
    title: "Iodine",
    translationId: "",
    aboutMealLetter: "Iodine",
    attr_id: -102,
    unit: "mcg",
  },
  {
    title: "Chromium",
    translationId: "",
    aboutMealLetter: "Chromium",
    attr_id: -103,
    unit: "mcg",
  },
  {
    title: "Molybdenum",
    translationId: "",
    aboutMealLetter: "Molybdenum",
    attr_id: -104,
    unit: "mcg",
  },
  {
    title: "Chloride",
    translationId: "",
    aboutMealLetter: "Chloride",
    attr_id: -105,
    unit: "mcg",
  },
  {
    title: "Taurine",
    translationId: "",
    aboutMealLetter: "Taurine",
    attr_id: -106,
    unit: "mg",
  },
  {
    title: "Inositol",
    translationId: "",
    aboutMealLetter: "Inositol",
    attr_id: -107,
    unit: "mg",
  },
];

export const ADMINISTERED_BY_OPTIONS = {
  MOUTH: {
    id: "MOUTH",
    translationId: "appText.dietDiary.administeredBy.mouth",
    feedingTypeRequired: false,
  },
  PEG_TUBE_G_TUBE: {
    id: "PEG_TUBE_G_TUBE",
    translationId: "appText.dietDiary.administeredBy.pegTube_gTube",
    feedingTypeRequired: true,
  },
  NG_TUBE: {
    id: "NG_TUBE",
    translationId: "appText.dietDiary.administeredBy.ngTube",
    feedingTypeRequired: true,
  },
  J_TUBE: {
    id: "J_TUBE",
    translationId: "appText.dietDiary.administeredBy.jTube",
    feedingTypeRequired: true,
  },
  NJ_ND_TUBE: {
    id: "NJ_ND_TUBE",
    translationId: "appText.dietDiary.administeredBy.nj_ndTube",
    feedingTypeRequired: true,
  },
};

export const FEEDING_TYPE_OPTIONS = {
  BOLUS: {
    id: "BOLUS",
    translationId: "appText.dietDiary.feedingType.bolus",
    startEndTimeRequired: false,
  },
  CONTINUOUS: {
    id: "CONTINUOUS",
    translationId: "appText.dietDiary.feedingType.continuous",
    startEndTimeRequired: true,
  },
};

export const DIET_DIARY_TYPE_NAME = {
  STUDY_DRUG: "Study Drug",
};
